export default __webpack_public_path__ + "static/media/where-money-goes-figure.705dd2ba.svg";